import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Applogo } from "../Routes/ImagePath";
import "./rolesPage.css";

function RolesPage() {
  const roleData = [
    { id: 1, name: "Sales", image: require("../assets/img/icons/Sales.png") },
    { id: 2, name: "Credit", image: require("../assets/img/icons/Credit.png") },
    {
      id: 3,
      name: "Operation",
      image: require("../assets/img/icons/Operation.png"),
    },
    { id: 4, name: "Legal", image: require("../assets/img/icons/Legal.png") },
    {
      id: 5,
      name: "Technical",
      image: require("../assets/img/icons/Technical.png"),
    },
    { id: 6, name: "FCU", image: require("../assets/img/icons/FDU.png") },
    {
      id: 7,
      name: "Collection",
      image: require("../assets/img/icons/Collection.png"),
    },
    {
      id: 8,
      name: "CCU",
      image: require("../assets/img/icons/CCU.png"),
    },
    {
      id: 9,
      name: "IT",
      image: require("../assets/img/icons/IT.png")
    }
  ];

  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const user = sessionStorage.getItem("user");
    const userData = JSON.parse(user);
    setRoles(userData.roles);
  }, []);

  const handleRoleClick = (roleName) => {
    
    if (roles.includes(roleName)) {
      sessionStorage.setItem("role", JSON.stringify(roleName));
      navigate("/employee-dashboard");
    } else {
      alert("You do not have access to this role.");
    }
  };

  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            <div className="container">
              <div className="account-logo">
                <Link to="/admin-dashboard">
                  <img src={Applogo} alt="Roha housing" style={{height: "8vh", width: "25vw"}} />
                </Link>
              </div>
              <div className="account-box">
                <div className="account-wrapper">
                  <div className="row">
                    {roleData &&
                      roleData.map((role) => (
                        <div key={role.id} className="col-4 col-md-3">
                          <div
                            className="card"
                            style={{ "--bs-card-spacer-x": "0.9rem" }}
                            onClick={() => handleRoleClick(role.name)}
                          >
                            <div className="card-header p-0 text-center">
                              <img
                                src={role.image}
                                alt={role.name}
                                className="img-fluid"
                              />
                            </div>
                            <div className="card-body text-center p-0">
                              <p className="card-title mb-0 fs-6">
                                {role.name}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                  <div className="account-footer"></div>
                  <div>
                    <div className="account-footer"></div>
                  </div>
                  {/* /Account Form */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    //         <div>
    //             <div className="account-page">
    //                 <div className="container">
    //                     <div className="account-content">
    //                         <div className="row d-flex justify-content-center">
    //                             <div className="col-md-12">
    //                                 <div className="text-center mt-4" style={{ marginBottom: "30px" }}>
    //                                     <Link to="/admin-dashboard">
    //                                         <img src={Applogo} alt="Roha housing" />
    //                                     </Link>
    //                                 </div>
    //                                 <div className="account-box">
    //     <div className="account-wrapper">
    //         <div className="row">
    //             {roleData.map((role) => (
    //                 <div key={role.id} className="col-md-3">
    //                     <div className="card"
    //                         style={{ '--bs-card-spacer-x': '0.9rem' }}
    //                         onClick={() => handleRoleClick(role.name)}
    //                     >
    //                         <div className="card-header text-center">
    //                             <img src={role.image} alt={role.name} className="img-fluid" />
    //                         </div>
    //                         <p style={{ textAlign: 'center' }}>
    //                             {roles.includes(role.name) ? role.name : 'No Access'}
    //                         </p>
    //                     </div>
    //                 </div>
    //             ))}
    //         </div>
    //         <div className="account-footer"></div>
    //     </div>
    // </div>

    //                             </div>
    //                             <div className="col-md-4">
    //                                 {/* <Sidebar roles={roleData} /> */}
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
  );
}

export default RolesPage;
